import Offers from "./Offers";
import Countries from "./Countries";
import Percentage from "./Percentage";
import Cpc from "./Cpc";
import Factor from "./Factor";

export default { Offers, Countries, Percentage, Cpc, Factor };


// WEBPACK FOOTER //
// ./src/services/API/components/Filler/index.js